module.exports = __webpack_public_path__ + "static/media/17-2.a5ab7a15.mp3";